import type { NotificationDTO } from "@/services/NotificationService";

/**
 * Where a notification takes you. Resolved here rather than stored on the backend,
 * because the admin and customer portals reach the same resource by different routes.
 *
 * Returns null when there is nothing to open, so the caller can render the row as plain
 * text instead of a dead link.
 */
export const notificationLink = (
  notification: NotificationDTO,
  isAdmin: boolean
): string | null => {
  // An explicit link wins: it exists for notifications the resource pair cannot express.
  if (notification.link) {
    return notification.link;
  }

  const id = notification.resourceId;
  if (!id) {
    return null;
  }

  switch (notification.resourceType) {
    // Offers have no route of their own; they are rendered inside their inquiry.
    case "OFFER":
    case "INQUIRY":
      return isAdmin
        ? `/admin/inquiry/details/${id}`
        : `/inquiry/details/${id}`;
    // Bookings are addressed by public reference, not numeric id.
    case "BOOKING":
      return isAdmin ? `/admin/bookings/${id}` : `/bookings/${id}`;
    case "BILL":
      return isAdmin ? `/admin/bills/${id}` : null;
    case "COMPANY":
      return isAdmin ? `/admin/companies/${id}` : null;
    default:
      return null;
  }
};
